import { useState } from 'react';
import { useIntl } from 'react-intl';
import { toast } from 'react-toastify';
import { deleteEquipment, updateEquipment } from '../../../services';
import PrimaryButton from '../../FormElements/PrimaryButton';
import Loading from '../../Loading';
import Modal from '../../UIelements/Modal';
import * as Styled from './styles';

type ModalProps = {
  id: number;
  token: string;
  onCancel: () => void;
  onUpdateList: () => Promise<void>;
};

const ModalUnlinkEquipment = (props: ModalProps) => {
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      setIsLoading(true);

      await deleteEquipment(props.id, props.token);
      toast.success(intl.formatMessage({ id: 'equipamento desvinculado com sucesso!' }).toUpperCase());
      props.onUpdateList();
      props.onCancel();
    } catch (error) {
      console.error(error)
      toast.error(intl.formatMessage({ id: 'equipment.ocorreu um erro. Tente novamente mais tarde' }).toUpperCase());
    } finally {
      setIsLoading(false);
    };
  };

  const content = (
    <Styled.Content>
      <Styled.Paragraph>
        {intl.formatMessage({ id: 'equipment.unlink.paragrafo 1' })}
      </Styled.Paragraph>
      <Styled.Paragraph>
        {intl.formatMessage({ id: 'equipment.unlink.paragrafo 2' })}
      </Styled.Paragraph>
    </Styled.Content>
  );

  const loading = <Loading />;

  const footer = (
    <>
      <PrimaryButton
        type='button'
        size='buttonModal'
        model='confirmation-gradient-modal'
        width='108px'
        onClick={handleSubmit}
      >
        {intl.formatMessage({ id: 'equipment.sim' })}
      </PrimaryButton>
      <PrimaryButton
        type='button'
        size='buttonModal'
        model='cancellation'
        width='108px'
        onClick={props.onCancel}
      >
        {intl.formatMessage({ id: 'equipment.não' })}
      </PrimaryButton>
    </>
  );
  return (
    <Modal
      title={intl.formatMessage({ id: 'desvincular equipamento' })}
      width='500px'
      showButtonClose={false}
      children={isLoading ? loading : content}
      footer={footer}
      onCancel={props.onCancel}
      onSubmit={handleSubmit}
    />
  );
};

export default ModalUnlinkEquipment;
